/**
 *
 * To use this country picker, create two select lists with classes country-picker and state-picker.
 * Then give them both attributes named picker-pair with the same value
 *
 */
$(document).ready(function ($) {

    $('.country-picker').each(function () {
        var pickerPair = $(this).attr('picker-pair');
        var countries = $(this);
        var states = $(`.state-picker[picker-pair="${pickerPair}"]`);
        var dropdownParent = $(this).closest('div');

        loadCountries();

        countries.change(function () {
            loadStates($(this).val());
        });

        function loadCountries() {
            $.get('/api/countries', function (data) {
                var html = '';
                var currentVal = countries.val() || countries.attr('value');
                for (var i = 0; i < data.length; i++) {
                    var key = data[i].id;
                    var value = data[i].country;
                    html += `<option value="${key}">${value}</option>`;
                }
                countries.html(html);
                countries.val(currentVal);

                countries.select2({
                    width: '100%',
                    dropdownParent: dropdownParent,
                });

                loadStates(currentVal);
            });
        }

        function loadStates(country) {
            if (!country) return;
            $.get('/api/states', {
                country: country
            }, function (data) {
                var html = '';
                var currentVal = states.val() || states.attr('value');
                for (var i = 0; i < data.length; i++) {
                    var key = data[i].id;
                    var value = data[i].state;
                    html += `<option value="${key}">${value}</option>`;
                }
                states.html(html);
                states.val(currentVal);

                states.select2({
                    width: '100%',
                    dropdownParent: dropdownParent,
                });
            });
        }
    });
});
